import React, { useState } from 'react'
import { HiOutlineClipboardList } from 'react-icons/hi'
import CustomTable from '../../shared/CustomTable'
import {
  consultationRequestsColumns,
} from '../../constants/ProfillingConstants'
import { CancelIcon, EditIcon } from '../../utils/TableActionIcons'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
const ReuseableModal = React.lazy(() =>
  import('../../shared/ReuseableModal')
)

function ConsultNote () {
  const { t } = useTranslation()
  const { isLoading, patientDoctorNotes } = useSelector(
    state => state?.notes
  )
  const [openRequestForm, setOpenRequestForm] = useState(false)
  const [selectedConsultationRequest, setSelectedConsultationRequest] =
    React.useState(null)
  const actions = {
    header: t('Actions'),
    body: ActionTempelate,
    headerCellClass: '!bg-gray-200'
  }
  function ActionTempelate (row) {
    return (
      <div className='flex gap-1'>
        <CancelIcon iconSize={18} />
        <EditIcon
          iconSize={18}
          onClick={() => {
            setSelectedConsultationRequest(row)
            setOpenRequestForm(true)
          }}
        />
      </div>
    )
  }
  const columns = [...consultationRequestsColumns(t)]
  return (
    <div>
      <div className='mt-4'>
        <CustomTable
          columns={columns}
          data={
            patientDoctorNotes?.data?.consult_notes?.map(data => ({
              ...data,
              createdAt: data?.created_at,
              updatedAt: data?.updated_at
            })) || []
          }
        />
      </div>
      {/* <ReuseableModal
        isVisible={openRequestForm}
        position='top'
        title={selectedConsultationRequest ? 'Edit Request' : 'Add New Request'}
        HeaderIcon={HiOutlineClipboardList}
        onClose={() => {
          setOpenRequestForm(false)
        }}
      >
        <RequestConsultationForm
          selectedConsultationRequest={selectedConsultationRequest}
          setSelectedConsultationRequest={setSelectedConsultationRequest}
          setOpenRequestForm={setOpenRequestForm}
        />
      </ReuseableModal> */}
    </div>
  )
}

export default ConsultNote
